// The stage board close-up: the app's real lifecycle columns, with illustrative cars.
export const BOARD = [
    {
        tone: 'watching',
        name: 'Watching',
        count: 6,
        cars: [
            {
                n: '1997 Subaru Sambar TC',
                m: 'KS4-341208 · Lot 18077'
            },
            {
                n: '1997 Toyota Supra SZ-R',
                m: 'JZA80-0034567 · Lot 22914'
            }
        ]
    },
    {
        tone: 'bidding',
        name: 'Bidding',
        count: 2,
        cars: [
            {
                n: '1996 Mitsubishi Delica Space Gear',
                m: 'PE8W · Bid ¥720,000'
            }
        ]
    },
    {
        tone: 'won',
        name: 'Won',
        count: 1,
        cars: [
            {
                n: '1999 Nissan Stagea RS Four V',
                m: 'WGNC34-012345 · ¥1,280,000'
            }
        ]
    },
    {
        tone: 'importing',
        name: 'Importing',
        count: 3,
        cars: [
            {
                n: '1998 Mitsubishi Minicab',
                m: 'U42T · RoRo, ETA 14 Apr'
            },
            {
                n: '1995 Toyota Land Cruiser VX',
                m: 'HDJ81V · Customs'
            }
        ]
    },
    {
        tone: 'owned',
        name: 'In stock',
        count: 4,
        cars: [
            {
                n: '1999 Honda Acty',
                m: 'HA4 · Title pending'
            }
        ]
    }
];
